// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tour-address .expand-panel.open .panel {\n  margin-top: 1rem;\n}\n.tour-address .google-map-container {\n  width: 100% !important;\n}\n", ""]);
// Exports
module.exports = exports;
